import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App, FinishLink } from "./App.tsx";
import "./styles/console.css";
import "./styles/legacy.css";

const finishing = /\/app\/auth(\.html)?$/.test(location.pathname);
createRoot(document.getElementById("root")!).render(<StrictMode>{finishing ? <FinishLink /> : <App />}</StrictMode>);
